import { reactive, computed } from "vue"

const state = reactive({
  userRole: "guest",
  artists: [],
  songs: [],
  playlists: [],
  currentArtistId: null,
  artistSongsFetch: {}
})

async function fetchSongsForArtist(artistId) {
  if (!artistId) return

  const hasSongs = state.songs.some(s => s.artist_id == artistId)
  const fetchState = state.artistSongsFetch[artistId]

  if (hasSongs || fetchState === true) return
  if (fetchState instanceof Promise) return fetchState

  const promise = fetch(`/artists/${artistId}/songs.json`)
    .then(async r => {
      if (!r.ok) throw new Error(`Failed to fetch songs for artist ${artistId}`)
      const { songs } = await r.json()
      const existingIds = new Set(state.songs.map(s => s.id))
      songs.forEach(s => {
        if (!existingIds.has(s.id)) state.songs.push(s)
      })
      state.artistSongsFetch[artistId] = true
    })
    .catch(err => {
      delete state.artistSongsFetch[artistId]
      throw err
    })

  state.artistSongsFetch[artistId] = promise
  return promise
}

const store = reactive({
  get userRole() { return state.userRole },

  artists: computed(() => state.artists),
  songs: computed(() => state.songs),
  playlists: computed(() => state.playlists),
  sharedArtists: computed(() => state.artists.filter(a => a.is_shared)),
  sharedPlaylists: computed(() => state.playlists.filter(p => p.is_shared)),

  uploadAutocompleteData: computed(() => {
    const artists = state.artists.filter(a => !a.sample)
    const artistIDs = new Set(artists.map(a => a.id))

    const result = {}
    for (const artist of artists) {
      result[artist.name] = {}
    }

    for (const song of state.songs) {
      if (!artistIDs.has(song.artist_id) || song.last_mix_version == null)
        continue
      const artist = state.artists.find(a => a.id === song.artist_id)
      if (artist) result[artist.name][song.name] = song.last_mix_version
    }

    return result
  }),

  artistForRoute(route) {
    if ( route.params.artistID ) {
      return this.artists.find(a => a.id == route.params.artistID)
    } else if ( route.params.songID ) {
      return this.artistForSongID(route.params.songID)
    } else {
      return undefined
    }
  },
  artistForSongID(songID) {
      const song = state.songs.find(s => s.id == songID)
      return song ? state.artists.find(a => a.id == song.artist_id) : undefined
  },
  fetchSongsForArtist,
  init() {
    const sd = window.mbPreload?.sidebar || {}

    if ( sd.userRole ) state.userRole = sd.userRole
    if ( sd.artists ) state.artists = sd.artists
    if ( sd.songs ) state.songs = sd.songs
    if ( sd.playlists ) state.playlists = sd.playlists
  }
})

export default store
